<ion-app class="pinch-control">
  <ion-router-outlet></ion-router-outlet>
  <custom-loading></custom-loading>
</ion-app>